export default "__VITE_ASSET__FDIH8OyA__"